import React from "react";
import { motion } from "framer-motion";

// Importi ikona (prilagodi putanje tvojim Assetsima)
import TerraceIcon from "../../Assets/Icons/terrace.png";
import ParkingIcon from "../../Assets/Icons/parking.png";
import TakeawayIcon from "../../Assets/Icons/takeaway.png";
import PetsIcon from "../../Assets/Icons/pets.png";
import CardIcon from "../../Assets/Icons/payment.png";

const infoData = [
  { id: 1, icon: TerraceIcon, text: "Vanjska terasa" },
  { id: 2, icon: ParkingIcon, text: "Parking" },
  { id: 3, icon: TakeawayIcon, text: "Preuzimanje" },
  { id: 4, icon: PetsIcon, text: "Ljubimci dozvoljeni" },
  { id: 5, icon: CardIcon, text: "Plaćanje karticama" },
];

// Animacije za cijelu grupu
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 },
  },
};

// Animacija za svaku pojedinu ikonu
const itemVariants = {
  hidden: { opacity: 0, scale: 0.8, y: 20 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

const HomeInfo = () => {
  return (
    <section className="home-info">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Naše pogodnosti
        </motion.h2>
        <motion.div
          className="info-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {infoData.map((item) => (
            <motion.div
              key={item.id}
              className="info-item"
              variants={itemVariants}
            >
              <div className="icon-box">
                <img src={item.icon} alt={item.text} />
              </div>
              <p>{item.text}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default HomeInfo;
